// src/components/layout/PageHeader.jsx
import React from 'react';

const PageHeader = () => (
  <div className="text-center" dir="rtl">
    
    <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold leading-tight">
      <span className="bg-gradient-to-l from-indigo-700 to-purple-500 bg-clip-text text-transparent">
        ברוכים הבאים לפלטפורמה 
      </span>
    </h1>

    <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-gray-800 mt-1">
      DoroosOnline
    </h2>

    <p className="text-sm sm:text-base text-gray-500 mt-2 sm:mt-3 max-w-sm sm:max-w-md mx-auto leading-relaxed">
      איך אתם משתמשים ב-DoroosOnline?
    </p>
    
  </div>
);

export default PageHeader;